/**
 * 申请单信息
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import MemberParamEdit from './MemberParamEdit';
import OrgSelect from '../../ui/OrgSelect';
import { global_data } from '../../ui/auth'

class MemberParamIndex extends React.Component {
    columns = [{
        title: '会员名称',
        dataIndex: 'memberName',
        width: '10%',
    }, {
        title: '参数名',
        dataIndex: 'name',
        width: '10%',
    }, {
        title: '参数编码',
        dataIndex: 'code',
        width: '10%',
    }, {
        title: '备注',
        dataIndex: 'remark',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("MEMBER_PARAM_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("MEMBER_PARAM_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, text)} />
                </Tooltip>
                :""}
            </div>
        ),
    }];

    state = {
        visible: false,
        editData: {},  //编辑的数据

        loadData: '',
        queryData: {}, //查询数据

    };

    add = () => {
        //let orgCode = this.state.orgList[0].code;
        this.setState({editData: {}, visible: true});
    }

    update = (info, e) => {
        this.setState({ editData: info, visible: true});
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    }

    delete = (info, e) => {
        messager.confirm("是否删除该参数？", () => {
            http.post({
                url: '/memberParam/deleteMemberParam',
                data: { id: info },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("删除成功！");
                }
            });
        });
    }

    //查询
    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="会员名称/参数名/参数编码"
                                    onSearch={this.inputSearch.bind(this, "queryString")}
                                    enterButton
                                    style={{ width: '250px', marginRight: '10px' }}
                                />
                                <OrgSelect style={{ width: '200px'}} 
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("MEMBER_PARAM_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/memberParam/findMemberParamPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <MemberParamEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
            </div>
        )
    }

}

export default MemberParamIndex;